// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabA_TheComp__xxEJf"};